<!--
 * @Description:班组简介页
-->
<template>
  <div class="teamIntroduction">
    <el-row>
      <el-col :span="8" v-if="data.workTypeDescription">
        <div
          class="item_text single_hide"
          style="display: flex;"
        >
          <span class="color6">工种简介：</span>
          <div @mouseenter="handleShowTooltip($event)">
            <el-tooltip
              popper-class="popperCustoms"
              :visible-arrow="false"
              :disabled="showTooltip"
              placement="bottom"
              class="single_hide"
              effect="light"
            >
              <span
                class="item_data color3"
                style="vertical-align: top; display: inline-block; width: 265px"
              >
                {{ data.workTypeDescription ? data.workTypeDescription : "/" }}</span
              >
              <div slot="content" style="color: #666">
                {{ data.workTypeDescription }}
              </div>
            </el-tooltip>
          </div>
        </div>
      </el-col>
      <el-col :span="8" v-if="data.conditions">
        <div
          class="item_text single_hide"
          style="display: flex;"
        >
          <span class="color6">要求条件：</span>
          <div @mouseenter="handleShowTooltip($event)">
            <el-tooltip
              popper-class="popperCustoms"
              :visible-arrow="false"
              :disabled="showTooltip"
              placement="bottom"
              class="single_hide"
              effect="light"
            >
              <span
                class="item_data color3"
                style="vertical-align: top; display: inline-block; width: 265px"
              >
                {{ data.conditions ? data.conditions : "/" }}</span
              >
              <div slot="content" style="color: #666">
                {{ data.conditions }}
              </div>
            </el-tooltip>
          </div>
        </div>
      </el-col>
      <el-col
        :span="8"
        v-if="data.teamExplainVo && data.teamExplainVo.threeLevelWorkTypeName"
      >
        <div class="item_text single_hide" style="display: flex">
          <span class="color6">工种构成：</span>
          <div @mouseenter="handleShowTooltip($event)">
            <el-tooltip
              popper-class="popperCustoms"
              :visible-arrow="false"
              :disabled="showTooltip"
              placement="bottom"
              class="single_hide"
              effect="light"
            >
              <span
                class="item_data color3"
                style="vertical-align: top; display: inline-block; width: 265px"
              >
                {{
                  data.teamExplainVo.threeLevelWorkTypeName
                    ? data.teamExplainVo.threeLevelWorkTypeName
                    : "/"
                }}</span
              >
              <div slot="content" style="color: #666">
                {{ data.teamExplainVo.threeLevelWorkTypeName }}
              </div>
            </el-tooltip>
          </div>
        </div>
      </el-col>
      <el-col :span="8" v-if="data.workload">
        <div class="item_text single_hide" style="display: flex">
          <span class="color6">要求年施工量：</span>
          <div @mouseenter="handleShowTooltip($event)">
            <el-tooltip
              popper-class="popperCustoms"
              :visible-arrow="false"
              :disabled="showTooltip"
              placement="bottom"
              class="single_hide"
              effect="light"
            >
              <span
                class="item_data color3"
                style="vertical-align: top; display: inline-block; width: 265px"
              >
                {{ 
                  data.workload?data.workload:"/" 
                  }}</span
              >
              <div slot="content" style="color: #666">
                {{ data.workload }}
              </div>
            </el-tooltip>
          </div>
        </div>
      </el-col>
      <el-col :span="8" v-if="data.teamExplainWorkArea&&data.teamExplainWorkArea.length">
        <div class="item_text" style="display: flex">
          <span class="color6">计划工作区域：</span>
          <div @mouseenter="handleShowTooltip($event)">
            <el-tooltip
              popper-class="popperCustoms"
              :visible-arrow="false"
              :disabled="showTooltip"
              placement="bottom"
              class="single_hide"
              effect="light"
            >
              <span
                class="item_data color3"
                style="vertical-align: top; display: inline-block; width: 265px"
              >
                {{
                  data.teamExplainWorkArea.length
                    ? data.teamExplainWorkArea.map(i => i.name).toString()
                    : "/"
                }}</span
              >
              <div slot="content" style="color: #666">
                {{ data.teamExplainWorkArea.map(i => i.name).toString() }}
              </div>
            </el-tooltip>
          </div>
        </div>
      </el-col>
      <div v-if="data.teamExplainFieldList && data.teamExplainFieldList.length">
        <el-col
          :span="8"
          class="detail-item"
          v-for="(field, index) in data.teamExplainFieldList"
          :key="index"
        >
          <div class="item_text" style="display: flex">
          <div @mouseenter="handleShowTooltip($event)">
            <el-tooltip
              popper-class="popperCustoms"
              :visible-arrow="false"
              :disabled="showTooltip"
              placement="bottom"
              class="single_hide"
              effect="light"
            >
              <span
                class="item_data color6"
                style="vertical-align: top; display: inline-block; max-width:70px"
              >
                {{ field.name }}:</span
              >
              <div slot="content" style="color: #666">
               {{ field.name }}:
              </div>
            </el-tooltip>
          </div>
          <div @mouseenter="handleShowTooltip($event)">
            <el-tooltip
              popper-class="popperCustoms"
              :visible-arrow="false"
              :disabled="showTooltip"
              placement="bottom"
              class="single_hide"
              effect="light"
            >
              <span
                class="item_data color3"
                style="vertical-align: top; display: inline-block; width: 265px"
              >
                {{field.content}}</span
              >
              <div slot="content" style="color: #666;width: 300px;line-height:18px">
               {{field.content}}
              </div>
            </el-tooltip>
          </div>
        </div>
        </el-col>
      </div>
    </el-row>
    <div>
      <div
        v-if="data.materialList && data.materialList.length"
        style="color: #666; font-size: 14px; margin-bottom: 10px"
      >
        包含辅材:
      </div>
      <materialTable
        v-if="data.materialList && data.materialList.length"
        :data="data.materialList"
        :loadingTrue="loadingTrue"
      ></materialTable>
    </div>
    <div>
      <div
        v-if="data.equipmentList && data.equipmentList.length"
        style="color: #666; font-size: 14px; margin: 20px 0 10px 0"
      >
        包含机械设备:
      </div>
      <equipmenTable
        v-if="data.equipmentList && data.equipmentList.length"
        :data="data.equipmentList"
        :loadingTrue="loadingTrue"
      ></equipmenTable>
    </div>
  </div>
</template>

<script>
export default {
  name: "teamIntroduction",
  props: {
    data: {
      type: Object
    },
    loadingTrue: {
      type: Boolean
    }
  },
  data() {
    return {
      showTooltip: false
    }
  },
  computed: {
    isLogin: function () {
      return this.$store.state.token
    }
  },
  components: {
    materialTable: () =>
      import("@/views/IndividualPage/components/materialTable.vue"), // 包含材料列表
    equipmenTable: () =>
      import("@/views/IndividualPage/components/equipmenTable.vue") // 包含设备列表
  },
  created() {},
  methods: {
    //内容超出时,hover显示所有文本信息
    handleShowTooltip(event) {
      let cell = event.target.querySelector(".el-tooltip")
      this.showTooltip = cell.scrollWidth === cell.offsetWidth
    },
    /**
     * 格式化页面显示的文件大小
     * @param fileSize 文件大小
     */
    formatFileSize(fileSize = 0) {
      fileSize = Number(fileSize)
      if (fileSize / 1024 > 10) {
        return `${(fileSize / 1024).toFixed(2)}M`
      } else {
        return `${Math.ceil(fileSize)}kb`
      }
    }
  },
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.teamIntroduction {
  .item_text {
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 12px;
    img {
      width: 24px;
      height: 24px;
      margin-right: 10px;
      vertical-align: middle;
      margin-top: -4px;
    }
    .bjCase {
      height: 20px;
      line-height: 20px;
      background: rgba(2, 134, 223, 0.1);
      margin-right: 10px;
      border-radius: 2px;
      color: #0286df;
      padding: 0px 5px;
      box-sizing: border-box;
      font-size: 12px;
      margin-top: 3px;
    }
  }
}
.single_hide {
  // 单行隐藏
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.color6 {
  color: #666666;
}
.color3 {
  color: #333333;
}
.detail-item {
  display: flex;
  .item-name {
    font-size: 14px;
    flex-shrink: 0;
    color: var(--FC6);
  }

  .item-value {
    font-size: 14px;
    color: var(--FC3);
  }
}
</style>
<style lang="scss" rel="stylesheet/scss">
.popperCustoms {
  padding: 5px 10px !important;
  &.is-light {
    background: #ffffff !important;
    border: 1px solid #666666;
    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius: 0;
    opacity: 1 !important;
    color: #666666 !important;
  }
}
</style>
